module.exports = __webpack_public_path__ + "static/media/applestore.69e5b9aa.svg";